// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agent/:id/logs/calling_locations" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentIdLogsCallingLocations } from "./constants";
import type { GenerativeAiAgentIdLogsCallingLocationsResult } from "./types";
import { isGenerativeAiAgentIdLogsCallingLocationsResult } from "./validators";

export const getGenerativeAiAgentIdLogsCallingLocations = reactQueryFetcherAdapter(
  generativeAiAgentIdLogsCallingLocations,
  (
    signal: AbortSignal,
    id: string,
    appGroupId?: string
  ): Promise<GenerativeAiAgentIdLogsCallingLocationsResult> => {
    return fetch(
      `/generative_ai/agent/${id}/logs/calling_locations`,
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  },
  isGenerativeAiAgentIdLogsCallingLocationsResult
);
